import { Box, Stack, Typography } from "@mui/material";
import { colors } from "../../theme";

type Props = {
  category: {
    label: string;
    value: string;
  };
  selectedCategories: string[];
  onClick: (category: string) => void;
};

const CategoryCard = ({ category, selectedCategories, onClick }: Props) => {
  const isSelected = selectedCategories.includes(category.value);
  return (
    <Box
      key={category.value}
      border={`1px solid ${colors.grey10}`}
      borderRadius={4}
      overflow="hidden"
      onClick={() => onClick(category.value)}
      width="100%"
      sx={{ cursor: "pointer" }}
    >
      <Stack
        position="relative"
        gap={1}
        direction="row"
        alignItems="center"
        justifyContent="center"
        paddingY={2}
        paddingX={3}
        bgcolor={isSelected ? colors.black : colors.white}
      >
        <Typography variant="body2" color={isSelected ? colors.white : colors.black}>
          {category.label}
        </Typography>
      </Stack>
    </Box>
  );
};
export default CategoryCard;
